/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} People_No_MatchInputs */

const th_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบใครที่ชื่อนี้`)
};

const en_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody here by that name.`)
};

const ja_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その名前の人は見つかりません。`)
};

const zh_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这里没有叫这个名字的人。`)
};

const es_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aquí no hay nadie con ese nombre.`)
};

const pt_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguém aqui com esse nome.`)
};

const id_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada orang dengan nama itu di sini.`)
};

const fr_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personne de ce nom ici.`)
};

const tl_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang taong may ganoong pangalan dito.`)
};

const vi_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có ai tên vậy ở đây.`)
};

const ko_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그런 이름을 가진 사람이 없습니다.`)
};

const de_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier ist niemand mit diesem Namen.`)
};

const ru_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Здесь нет никого с таким именем.`)
};

const tr_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Burada bu adda kimse yok.`)
};

const it_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qui non c'è nessuno con quel nome.`)
};

const pl_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ma tu nikogo o tym imieniu.`)
};

const uk_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тут немає нікого з таким ім'ям.`)
};

const hi_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यहाँ उस नाम का कोई नहीं है।`)
};

const ar_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا أحد هنا بهذا الاسم.`)
};

const ms_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada sesiapa di sini dengan nama itu.`)
};

const bn_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই নামে এখানে কেউ নেই।`)
};

const zh_tw2_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這裡沒有叫這個名字的人。`)
};

const zh_hk2_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這裡沒有叫這個名字的人。`)
};

const ur_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس نام کا یہاں کوئی نہیں۔`)
};

const fa_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کسی با این نام اینجا نیست.`)
};

const sw_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna mtu mwenye jina hilo hapa.`)
};

const nl_people_no_match = /** @type {(inputs: People_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier is niemand met die naam.`)
};

/**
* | output |
* | --- |
* | "Nobody here by that name." |
*
* @param {People_No_MatchInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const people_no_match = /** @type {((inputs?: People_No_MatchInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<People_No_MatchInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_people_no_match(inputs)
	if (locale === "ja") return ja_people_no_match(inputs)
	if (locale === "zh") return zh_people_no_match(inputs)
	if (locale === "es") return es_people_no_match(inputs)
	if (locale === "pt") return pt_people_no_match(inputs)
	if (locale === "id") return id_people_no_match(inputs)
	if (locale === "fr") return fr_people_no_match(inputs)
	if (locale === "tl") return tl_people_no_match(inputs)
	if (locale === "vi") return vi_people_no_match(inputs)
	if (locale === "ko") return ko_people_no_match(inputs)
	if (locale === "de") return de_people_no_match(inputs)
	if (locale === "ru") return ru_people_no_match(inputs)
	if (locale === "tr") return tr_people_no_match(inputs)
	if (locale === "it") return it_people_no_match(inputs)
	if (locale === "pl") return pl_people_no_match(inputs)
	if (locale === "uk") return uk_people_no_match(inputs)
	if (locale === "hi") return hi_people_no_match(inputs)
	if (locale === "ar") return ar_people_no_match(inputs)
	if (locale === "ms") return ms_people_no_match(inputs)
	if (locale === "bn") return bn_people_no_match(inputs)
	if (locale === "zh-TW") return zh_tw2_people_no_match(inputs)
	if (locale === "zh-HK") return zh_hk2_people_no_match(inputs)
	if (locale === "ur") return ur_people_no_match(inputs)
	if (locale === "fa") return fa_people_no_match(inputs)
	if (locale === "sw") return sw_people_no_match(inputs)
	if (locale === "nl") return nl_people_no_match(inputs)
	return en_people_no_match(inputs)
});